/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

export const GetSetupProgress = {
  id: 'setup-progress.get',
  tag: 'Setup',
  summary: 'Get setup progress',
  description: 'Retrieve the progress of all setup steps',
  method: 'get',
  route: () => '/setup/progress',
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            steps: z.strictObject({
              superuser: ZodTypes.SetupStepProgress,
              organization: ZodTypes.SetupStepProgress,
              emailConfig: ZodTypes.SetupStepProgress,
            }),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
